module.exports = __webpack_public_path__ + "img/logo.2bda67ef.png";